import React from 'react'

const SignupSuccessModal = ({
  title = 'Account created successfully',
  message,
  buttonLabel = 'Continue to login',
  onContinue
}) => {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="signup-success-title"
    >
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
        <div className="mb-4 flex justify-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-green-100">
            <svg
              className="h-7 w-7 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        <h3 id="signup-success-title" className="mb-2 text-center text-xl font-semibold text-gray-900">
          {title}
        </h3>
        <p className="mb-6 text-center text-sm leading-relaxed text-gray-600">{message}</p>

        <button
          type="button"
          onClick={onContinue}
          className="w-full rounded-lg bg-[#00A5E6] px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-[#008FCC] focus:outline-none focus:ring-4 focus:ring-[#cceffd]"
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  )
}

export default SignupSuccessModal
